import * as React from "react";

export const StopTimer = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 2.60002C5.01756 2.60002 2.5999 5.01769 2.5999 8.00002C2.5999 10.9824 5.01756 13.4 7.9999 13.4C10.9822 13.4 13.3999 10.9824 13.3999 8.00002C13.3999 5.01769 10.9822 2.60002 7.9999 2.60002ZM1.3999 8.00002C1.3999 4.35494 4.35482 1.40002 7.9999 1.40002C11.645 1.40002 14.5999 4.35494 14.5999 8.00002C14.5999 11.6451 11.645 14.6 7.9999 14.6C4.35482 14.6 1.3999 11.6451 1.3999 8.00002ZM5.3999 6.00002C5.3999 5.66865 5.66853 5.40002 5.9999 5.40002H9.9999C10.3313 5.40002 10.5999 5.66865 10.5999 6.00002V10C10.5999 10.3314 10.3313 10.6 9.9999 10.6H5.9999C5.66853 10.6 5.3999 10.3314 5.3999 10V6.00002ZM6.5999 6.60002V9.40002H9.3999V6.60002H6.5999Z"
    />
);
